export default {
    "a.close": "</a>",
    "div.open": "<div>",
    "div.close": "</div>",
    "span.close": "</span>",
};
